module.exports = __webpack_public_path__ + "img/profile_stvldf.7bbd66b2.jpg";